module.exports = __webpack_public_path__ + "img/delivered-box-verification.06b47569.svg";